import { FC } from "react";

import * as Icons from "@livechat/design-system-icons";
import { Icon, IconProps, IconSource } from "@livechat/design-system-react-components";

export type IconName = keyof typeof Icons;

interface IProps extends Omit<IconProps, "source"> {
  iconName: IconName;
}

export const IconNameMapper: FC<IProps> = ({ iconName, ...props }) => {
  const iconSource = mapIconNameToIconSource(iconName);

  if (iconSource) {
    return <Icon source={iconSource} {...props} />;
  }

  // eslint-disable-next-line no-console
  console.error(`Icon ${iconName} not found in @livechat/design-system-icons`);
  return null;
};

export const mapIconNameToIconSource = (iconName: IconName): IconSource | undefined => {
  if (iconName in Icons) {
    // eslint-disable-next-line import/namespace
    return Icons[iconName];
  }

  return undefined;
};
